import React, { FC, ReactNode, useState } from 'react';
import { useKeyPressEvent } from 'react-use';

import { Background, Image } from './styles';

type PropTypes = {
  src?: string;
  alt?: string;
  children?: ReactNode;
};

export const ImageWithZoom: FC<PropTypes> = (props) => {
  const [zoom, setZoom] = useState(false);

  useKeyPressEvent('Escape', () => setZoom(false));

  return (
    <>
      <Background active={zoom} onClick={(): void => setZoom(false)} />
      <Image src={props.src} alt={props.alt} onClick={(): void => setZoom(true)} />

      {zoom && <Image src={props.src} alt={props.alt} opened />}
    </>
  );
};
